// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__X917W","Ingredient":"Order_Ingredient__30a8J"};